import * as React from 'react';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
import { SHOW_RIVER2_OPTIMIZATION } from '@/constants';

const { EFPic } = createEFPic('/media/river2/pc/');

const App: React.FC = () => {
    const { useEffect, useLang, useRouter, useRef } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const river2_G2_videoRef = useRef();
    let controller: any;

    useEffect(() => {
        controller = new ScrollMagic.Controller();
        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_G .G2-desc-box-sm .aniG2',
            triggerHook: 1,
            offset: 200,
            duration: 300,
        })
            .setTween(TweenMax.to('.river2_detials_G .G2-desc-box-sm .aniG2', 0.5, { opacity: 1 }))
            .addTo(controller);
    }, []);

    useEffect(() => {
        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_G .G3-desc-box .aniG3',
            triggerHook: 1,
            offset: 200,
            duration: 300,
        })
            .setTween(TweenMax.to('.river2_detials_G .G3-desc-box .aniG3', 0.5, { opacity: 1 }))
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_G .G3-image-box',
            triggerHook: 1,
        })
            .on('enter', () => {
                river2_G2_videoRef?.current?.current?.currentTime === 0;
            })
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_G .G3-image-box',
            triggerHook: 1,
            offset: 200,
        })
            .on('enter', () => {
                river2_G2_videoRef?.current?.play();
            })
            .addTo(controller);
    }, []);

    const getRiver2Optimization = () => {
        if (SHOW_RIVER2_OPTIMIZATION.includes(locale)) {
            return {
                title: t('river2.details.sec7_msg1_optimize_title'),
                desc: t('river2.details.sec7_msg1_optimize_desc'),
            };
        }
        return {
            title: t('river2.details.sec7_msg1_title'),
            desc: t('river2.details.sec7_msg1_desc'),
        };
    };

    return (
        <div className={`${css.G_7} river2_detials_G`}>
            <div className="desc-box G2-desc-box G2-desc-box-sm">
                <div className={`G2-image-box`}>
                    <div className="G2-image-box__rel">
                        <EFPic
                            name={['G2.webp', 'G2.png']}
                            className="fullImgs"
                            noUseSrcset={true}
                            alt={getRiver2Optimization().title}
                            aria-label={getRiver2Optimization().title}
                        />
                    </div>
                </div>
                <div className={`G2-title-box aniG2 optimization`}>
                    <p className="G2-title">{getRiver2Optimization().title}</p>
                    <p className={`G2-desc`}>{getRiver2Optimization().desc}</p>
                </div>
            </div>
            <div className="desc-box G2-desc-box  G3-desc-box">
                <div className={`G2-image-box G3-image-box`}>
                    <EFVideo
                        ref={river2_G2_videoRef}
                        sources={['/video/river2/details/SmartBattery.webm', '/video/river2/details/SmartBattery.mp4']}
                        width="100%"
                        height="100%"
                        className="fullImgs"
                        loop={false}
                    />
                </div>
                <div className={`G2-title-box aniG3 G3-title-box`}>
                    <p className="G2-title G3-title">{t('river2.details.sec7_msg2_title')}</p>
                    <p className="G2-desc G3-desc">{t('river2.details.sec7_msg2_desc')}</p>
                </div>
            </div>
        </div>
    );
};

export default App;
